import { createRootRoute, createRoute } from '@summer/react-kit';

export const DevicesManagementRoute = createRootRoute('devices');
export const DevicesListPage = DevicesManagementRoute;
export const NewDeviceRoute = createRoute(DevicesManagementRoute, 'new');

export const AdditionalDevicesManagementRoute = createRootRoute(
  'additional-devices'
);
export const NewAdditionalDeviceRoute = createRoute(
  AdditionalDevicesManagementRoute,
  'new'
);

export const BusinessPartnersManagementRoute = createRootRoute(
  'business-partners'
);
export const BusinessPartnerRoutePrefix = createRootRoute('business-partners');

export const BusinessPartnersListRoute = createRoute(
  BusinessPartnersManagementRoute,
  'list'
);
export const NewBusinessPartnerRoute = createRoute(
  BusinessPartnersManagementRoute,
  'new'
);

export const SubpartnersManagementRoute = createRootRoute('subpartners');

export const NewSubpartnerManagementRoute = createRootRoute('new-subpartner');

export const DoctorsRoute = createRootRoute('doctors');

export const LoginRoute = createRootRoute('login');
export const ForgetPasswordRoute = createRootRoute('forget-password');
export const ResetPasswordRoute = createRootRoute('reset-password');

export const PatientsRoute = createRootRoute('patients');
export const UsersRoute = createRootRoute('users');

export const OnboardingRoute = createRootRoute('onboarding');

export const NewPasswordRoute = createRoute(OnboardingRoute, 'new-password');

export const AccountRoute = createRootRoute('account');
export const MfaSettingsRoute = createRoute(AccountRoute, 'mfa');
export const MfaLoginRoute = createRoute(LoginRoute, 'mfa-verification');
